import moment from 'moment'; 
import Button from '@mui/material/Button';

const InfoWindowContent = (data, payload = null) => {
  switch(data.markerType) {
    case "well": {
      return (
        <div>
          <h6>{data.well_id}</h6>
          <p>Name: {data.well_name}</p>
          {/*<p><a href={"https://www.google.com/maps?q=" + data.lat + "," + data.lng + ""} target="_blank" rel="noreferrer">{`${data.lat.toFixed(5)}, ${data.lng.toFixed(5)}`}</a></p>*/}
        </div>
      );
    }
    case "treatmentWell":
    case "offsetWell":
    case "cartofactWell": {
      return (
        <div>
          <h6>Well Info</h6>
          <p>Operator: {data.operator}</p>
          {/*<p>Permit Number: {data.permit_number}</p>*/}
          <p>UWI/API: {data.unique_identifier}</p>
          <p>Well Name: {data.surface_location || ''}{`${data.lease_name || ''} ${data.well_name || ''} ${data.well_number || ''}`}</p>
          <p>TVD: {data.tvd}</p>
          {/*<p>Fluid: {data.fluid}</p>*/}
          {/*<p>Status: {data.status}</p>*/}
          {/*<p><a href={"https://www.google.com/maps?q=" + data.lat + "," + data.lng + ""} target="_blank" rel="noreferrer">{`${data.lat.toFixed(5)}, ${data.lng.toFixed(5)}`}</a></p>*/}
          {
            (payload?.action) && (
              <p><Button variant="outlined" size="small" onClick={() => { payload.action(data); }}>{payload.buttonText}</Button></p>
            )
          }
        </div>
      );
    }
    default: {
      return null;
    }
  }
}


export default InfoWindowContent;